<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2020-03-28 10:52:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-16 10:30:50
-->
<template>
     <div> 
        <div class="style-box-top">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-if="codeData.indexOf('321') != -1" label="站点可用性" name="first"></el-tab-pane>
            <el-tab-pane v-if="codeData.indexOf('323') != -1" label="首页不更新" name="second"></el-tab-pane>
            <el-tab-pane v-if="codeData.indexOf('328') != -1" label="栏目不更新" name="third"></el-tab-pane>
            <el-tab-pane v-if="codeData.indexOf('333') != -1" label="链接可用性" name="fourth"></el-tab-pane>
            <el-tab-pane v-if="codeData.indexOf('431') != -1" label="更多监测" name="five"></el-tab-pane>
          </el-tabs>
        </div>
         <siteAvailability  v-if="activeName == 'first' && codeData.indexOf('321') != -1"></siteAvailability>
         <homepageNotUpdated v-if="activeName == 'second' && codeData.indexOf('323') != -1"></homepageNotUpdated>
         <columnNotUpdated v-if="activeName == 'third' && codeData.indexOf('328') != -1"></columnNotUpdated>
           <linkAvailability v-if="activeName == 'fourth' && codeData.indexOf('333') != -1"></linkAvailability>
           <moreMonitoring v-if="activeName == 'five' && codeData.indexOf('431') != -1"></moreMonitoring>
    </div>
</template>

<script>
import siteAvailability from './components/site_availability.vue'
import homepageNotUpdated from './components/homepage_not_updated.vue'
import linkAvailability from './components/link_availability.vue'
import columnNotUpdated from './components/column_not_updated.vue'
import moreMonitoring from './components/more_monitoring.vue'
export default {
  components: {
    siteAvailability,
    homepageNotUpdated,
    linkAvailability,
    columnNotUpdated,
    moreMonitoring
  },
  data() {
    return {
      activeName: "first",
      codeData:[],
    };
  },

  mounted() {
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
     if(this.$route.query.activeName){
        this.activeName = this.$route.query.activeName
     }else{
          if(this.codeData.indexOf('321') == -1 && this.codeData.indexOf('323') == -1 && this.codeData.indexOf('328') == -1 && this.codeData.indexOf('431') == -1){
              this.activeName = "five";
          }
          else  if(this.codeData.indexOf('321') == -1 && this.codeData.indexOf('323') == -1 && this.codeData.indexOf('328') == -1){
                this.activeName = "fourth";
          }else if(this.codeData.indexOf('321') == -1 && this.codeData.indexOf('323') == -1){
                this.activeName = "third";
          }else if(this.codeData.indexOf('321') == -1){
                this.activeName = "second";
          }else{
              this.activeName = "first";
          }
     }
  },
  methods: {
    handleClick(tab, event) {
      
    },
  },
};
</script>

<style lang="less" scoped>
.style-box-top {
  padding: 24px;
  padding-bottom: 0px;
}

/deep/ .el-tabs__header{
  margin: 0px;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .el-tabs__header{
  margin: 0px;
}
</style>